import { requestCallCenter, unwrapEnvelopeValue } from "../../../service/CallCenterApi";
import { isDesktopApp } from "../../../utils/isDesktop";
import {
  assertCallingEnabled,
  isBrowserPhoneChannelEnabled,
  isCallingEnabled,
} from "../../../utils/orgFeatures";
import { disabledBrowserPhoneConfig } from "./browserPhoneConfigUtils";

export const getBrowserPhoneConfig = async () => {
  if (!isCallingEnabled()) {
    return disabledBrowserPhoneConfig("CALLING_DISABLED");
  }
  if (!isBrowserPhoneChannelEnabled()) {
    return disabledBrowserPhoneConfig(
      isDesktopApp() ? "DESKTOP_CALLING_DISABLED" : "WEB_CALLING_DISABLED"
    );
  }
  const envelope = await requestCallCenter({
    method: "get",
    url: "telephony/browser-phone/config",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load browser phone config");
};

export const getLinkusSdkSession = async () => {
  assertCallingEnabled();
  const envelope = await requestCallCenter({
    method: "get",
    url: "telephony/linkus-sdk/session",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load Linkus SDK session");
};

export const registerBrowserEvent = async (payload) => {
  assertCallingEnabled();
  const envelope = await requestCallCenter({
    method: "post",
    url: "telephony/browser-phone/register-event",
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to register browser phone event");
};

export const notifyCallStarted = async (payload) => {
  assertCallingEnabled();
  const envelope = await requestCallCenter({
    method: "post",
    url: "telephony/browser-phone/call-started",
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to send call-started event");
};

export const notifyCallEnded = async (payload) => {
  assertCallingEnabled();
  const envelope = await requestCallCenter({
    method: "post",
    url: "telephony/browser-phone/call-ended",
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to send call-ended event");
};

export const notifyCallFailed = async (payload) => {
  assertCallingEnabled();
  const envelope = await requestCallCenter({
    method: "post",
    url: "telephony/browser-phone/call-failed",
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to send call-failed event");
};

export const getTelephonyCalls = async () => {
  assertCallingEnabled();
  const envelope = await requestCallCenter({
    method: "get",
    url: "telephony/calls",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load telephony calls");
};

export const uploadCallRecording = async (callId, blob, providerReference) => {
  assertCallingEnabled();
  const formData = new FormData();
  const fileName = blob?.type?.includes("mpeg") ? "recording.mp3" : "recording.wav";
  formData.append("file", blob, fileName);
  if (providerReference) {
    formData.append("providerReference", providerReference);
  }
  const envelope = await requestCallCenter({
    method: "post",
    url: `calls/${callId}/recording`,
    data: formData,
  });
  return unwrapEnvelopeValue(envelope, "Failed to upload call recording");
};

export const syncCallRecording = async (callId) => {
  assertCallingEnabled();
  const envelope = await requestCallCenter({
    method: "post",
    url: `calls/${callId}/recording/sync`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to sync call recording");
};

export const addCallNote = async (callId, payload) => {
  assertCallingEnabled();
  const envelope = await requestCallCenter({
    method: "post",
    url: `telephony/calls/${callId}/notes`,
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to add call note");
};
